import { Component, OnInit, Input, Output, EventEmitter, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ToasterLoggerService } from '../../../../core/toaster-logger.service';
import { DealSheetService } from '../../../../ajs-upgraded-providers';

@Component({
    selector: 'vincue-modal',
    templateUrl: './vincue-modal.component-ng.html',
    styleUrls: ['./vincue-modal.component.scss']
})

export class VinCueModalComponent implements OnInit, AfterViewInit {
    public dealerId: number;
    public estimatedMileage: number;
    public primaryPhone: string;
    public customer: any;
    public vehicle: any;
    public fullAddress: string;
    public fullTrim: string;
    public appraisalId: string;
    public createDate: any;
    public deepLink: string;
    public hasLatestAppraisal: boolean = false;
    public acv: number;
    public userId: number;
    public users: any[];
    public usersList: any[] = [];
    public selectedSalespersonId: number = -1;
    public selectedAppraiserId: number = -1;
    @Output() onSaveChanges = new EventEmitter();

    constructor(
        public _bsModalRef: BsModalRef,
        public tService: TranslateService,
        private logger: ToasterLoggerService,
        @Inject(DealSheetService) private dealSheetService) {
    }

    public ngOnInit(): void {
        this._bsModalRef.hide();

        this.getLatestAppraisal(this.dealerId, this.vehicle.vin);

        if (this.vehicle.estimatedCurrentMileage) {
            this.estimatedMileage = this.vehicle.estimatedCurrentMileage;
        }
        else {
            this.estimatedMileage = null;
        }
        
        if (this.customer.cellPhoneNumber) {
            this.primaryPhone = this.customer.cellPhoneNumber.value;
        }
        else if (this.customer.homePhoneNumber) {
            this.primaryPhone = this.customer.homePhoneNumber.value;
        }
        else {
            this.primaryPhone = null;
        }

        this.getCustomerAddress();
        this.getFullTrim();
        this.buildUsersList();
        if (this.userId > 0) {
            const user = this.usersList.find(x => x.id === Number(this.userId));
            if (user) {
                this.selectedSalespersonId = this.userId;
            }
        }
    }

    public ngAfterViewInit(): void {
        this._bsModalRef.hide();
    }

    public cancelModal(): void {
        this._bsModalRef.hide();
    }

    public sendAppraisal(): void {
        let salesPerson;
        let appraiser;
        if (this.selectedSalespersonId) {
            const user = this.usersList.find(x => x.id === Number(this.selectedSalespersonId));
            if (user) {
                salesPerson = { firstName: user.firstName, lastName: user.lastName, email: user.email };
            }
        }
        if (this.selectedAppraiserId) {
            const user = this.usersList.find(x => x.id === Number(this.selectedAppraiserId));
            if (user) {
                appraiser = { firstName: user.firstName, lastName: user.lastName, email: user.email };
            }
        }
        const result = { salesPerson: salesPerson, appraiser: appraiser };
        this.onSaveChanges.emit(result);
        this._bsModalRef.hide();
    }

    private getLatestAppraisal(dealerId:number, vin:string) {
        return this.dealSheetService.getLatestAppraisalVinCue(dealerId, vin)
            .then(data => {
                if (data && data.appraisal) {
                    this.hasLatestAppraisal = true;
                    this.appraisalId = data.appraisal.id;
                    this.deepLink = data.deepLink;
                    this.createDate = data.appraisal.created;
                    this.acv = data.appraisal.acv
                }
                else {
                    this.hasLatestAppraisal = false;
                }
            });
    }

    private getCustomerAddress() {
        var address1 = '';
        var address2 = '';
        if (this.customer) {

            if (this.customer.address.streetAddress)
                address1 = this.customer.address.streetAddress
            else
                address1 = '';

            if (this.customer.address.streetAddress2)
                address2 = ' ' + this.customer.address.streetAddress2;
            else
                address2 = ' ';

            this.fullAddress = address1 + address2 + ', ' + this.customer.address.city + ', ' + this.customer.address.stateName + ', ' + this.customer.address.normalizedZipCode;
        }
    }

    private getFullTrim() {
        this.fullTrim = this.vehicle.yearID + " " + this.vehicle.makeName + " " + this.vehicle.trimFullName;
    }

    public buildUsersList(): void {
        for (let i = 0; i < this.users.length; i++) {
            //Must create a new array and not reference the binding
            //as it can change the parent array. filter and add only user's with type id 1 that is client
            if (this.users[i].userTypeId == 1)
                this.usersList.push(this.users[i]);
        }
        // sort it to ascending order by fullName
        this.usersList.sort(this.dynamicSort("fullName"));
    }

    public dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }
}



